import { Output, EventEmitter, ChangeDetectorRef, OnInit } from '@angular/core';
import { WorkFieldInputChangeEvent } from '../../../events/work-field-input-change-event';
import { FormControl, Validators } from '@angular/forms';
import { E5coreUiWorkFieldTypeComponentBase } from '../../../components/e5core-ui-work-field/e5core-ui-work-field-type-component-base';

export class E5coreUiWorkFieldTypeCheckboxBaseComponent extends E5coreUiWorkFieldTypeComponentBase implements OnInit {

	@Output() valueChange = new EventEmitter<WorkFieldInputChangeEvent>();

	formControl: FormControl;

	ngOnInit() {
		const validators = [];
		if (this.field && this.field.isRequired) {
			validators.push(Validators.required);
		}
		// Convert e5 "", "True" and "False" to angular numeric.
		const state: boolean = (this.property && this.property.value && this.property.value.toLowerCase() === 'true');
		this.formControl = new FormControl({
			value: state,
			disabled: this.field.isReadOnly
		}, validators);
		this.formControl.markAsTouched();
		const error = this.getError();

		this.workItem$.subscribe(
			wi => {
				if (this.property) {
					let checked: boolean = this.property.value && this.property.value.toLowerCase() == "true";
					if (this.formControl.value != checked)
						this.formControl.setValue(checked);
				}
			}
		)
	}

	protected getError(): string {
		let error = '';
		if (this.formControl.hasError('required')) {
			error = 'required';
		}
		return (error);
	}

	changeValue($event) {
		this.valueChange.emit({ $event: $event, value: this.formControl.value, error: this.getError() });
	}

}
